<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>List of Buyers</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<!-- main row for all icons  -->
<div class="col-md-12">
	<div class="card card-primary card-outline">
		<div class="card-body overflow-auto">
			<div class="card-body overflow-auto">
			<form @submit.prevent="getUsers()" @keydown="userForm.onKeydown($event)" role="form">
			<div class="row" style="margin-top:10px;">
				<div class="col-sm-3" id="filterName">
        	<input class="form-control" type="text" v-model="searchName" placeholder="Search By Name">
        </div>
        <div class="col-sm-3" id="filterNumber">
        	<input class="form-control" type="number" v-model="searchNumber" placeholder="Search By Number" min="10">
        </div>
        <div class="col-sm-3">
        	<button class="btn btn-primary" type="submit"><i class="fa fa-search"></i> Search</button>
        </div>
			</div>
			</form>
			<img v-if="users==''" src="../images/nodata.svg">
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
      	<tbody>
        	<tr v-if="users!=''" v-for="user in users" :key="user.id">
          	<td>{{user.name}}</td>
          	<td>{{user.buyer_name}}</td>
          	<td>{{user.email}}</td>
          	<td>{{user.mobile}}</td>
                <td>
                    <p><button class="btn btn-primary" style="width:100%" @click="openAddressModal(user)"><i class="fa fa-plus"></i> Address</button></p>
                    <p><button class="btn btn-secondary" style="width:100%" @click="openGSTModal(user)"><i class="fa fa-plus"></i> GST</button></p>
                </td>
          	<td>
          		<button class="btn btn-primary fa fa-file-invoice-dollar" @click="showgst(user.gsts)"></button>
          		<button class="btn btn-danger fa fa-address-card" @click="showaddress(user.addresses)"></button>
          		<button class="btn btn-danger fa fa-edit" @click="getUser(user.id)"></button>
          		<button class="btn btn-danger fa fa-wrench" @click="pwModal(user.id)"></button>
          	</td>
          </tr>
        </tbody>
      </datatable>

    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getUsers(pagination.prevPageUrl)"
        @next="getUsers(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</div>
</section>
    <!-- /.content -->
<div class="modal" tabindex="-1" role="dialog" id="gstModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">GST Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">GST Number</th>
      <th scope="col">Details</th>
        <th scope="col">Validity</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(g, index) in gst">
      <th scope="row" >{{index+1}}</th>
      <td>{{g.gst_number}}</td>
      <td>{{g.details}}</td>
        <td v-if="g.is_active=='Unverified'" class="badge-danger">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" :id="'gstu'+index" @input="changeGST('Verified', g.id)">
                <label class="custom-control-label" :for="'gstu'+index">Unverified</label>
            </div>
        </td>
        <td v-else class="badge-success">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" :id="'gstv'+index" @input="changeGST('Unverified', g.id)" checked>
                <label class="custom-control-label" :for="'gstv'+index">Verified</label>
            </div>
        </td>
<!--        <td>-->
<!--            <button class="btn btn-primary fa fa-edit" @click="editGST(g)"></button>-->
<!--            <button class="btn btn-danger fa fa-trash" @click="changeGST('Inactive', t.id)"></button>-->
<!--        </td>-->
    </tr>

  </tbody>
</table>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
	</div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="addressModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Addresses</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">House/Room</th>
      <th scope="col">District</th>
      <th scope="col">State</th>
      <th scope="col">Country</th>
      <th scope="col">Pincode</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(a, index) in addresses">
      <th scope="row" >{{index+1}}</th>
      <td>{{a.address1}}, {{a.address2}}, {{a.address3}}</td>
      <td>{{a.district}}</td>
      <td>{{a.state}}</td>
      <td>{{a.country}}</td>
      <td>{{a.pincode}}</td>
    </tr>

  </tbody>
</table>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
	</div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="userModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">User Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form @submit.prevent="addContact" @keydown="userForm.onKeydown($event)" role="form">
      <div class="modal-body">
      	<div :class="['form-group', errors.name ? 'has-error' : '']">
									<label for="nf-fname">Name</label>
									<input class="form-control disabledInitially" v-model="userForm.name" id="nf-fname" type="text" name="name" placeholder="Enter Your Name">
									<span v-if="errors.name" :class="['badge bg-danger']">Enter a valid name.</span>
								</div>
								<div :class="['form-group', errors.buyer_name ? 'has-error' : '']">
									<label for="nf-lname">Buyer Name</label>
									<input class="form-control disabledInitially" v-model="userForm.buyer_name" id="nf-lname" type="text" name="buyer_name" placeholder="Enter Your Buyer Name">
									<span v-if="errors.buyer_name" :class="['badge bg-danger']">Enter a valid Buyer name.</span>
								</div>
								<div :class="['form-group', errors.mobile ? 'has-error' : '']">
									<label for="number1">Number</label>
									<input class="form-control disabledInitially" v-model="userForm.mobile" id="number1" type="number" name="phone1" placeholder="Enter Primary Phone Number" min="1000000000">
									<span v-if="errors.mobile" :class="['badge bg-danger']">Enter a valid phone number.</span>
								</div>
								<div :class="['form-group', errors.email ? 'has-error' : '']">
									<label for="email">E-mail</label>
									<input class="form-control disabledInitially" v-model="userForm.email" id="email" type="email" name="email" placeholder="Enter Your E-mail">
									<span v-if="errors.email" :class="['badge bg-danger']">Enter a valid E-mail.</span>
								</div>
      </div>
      <div class="modal-footer">
      	<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      	<button type="submit" class="btn btn-primary">Submit</button>
      </div>
      </form>
    </div>
	</div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="pwModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Change Password</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form @submit.prevent="changePassword" @keydown="passwordForm.onKeydown($event)" role="form">
      <div class="modal-body">
								<div :class="['form-group', errors.password ? 'has-error' : '']">
                        		<label>New Password</label>
                        		<input type="password" name="newpassword" class="form-control disabledPwInitially" v-model="passwordForm.password" placeholder="Enter the New Password">
                        		<span v-if="errors.password" :class="['badge bg-danger']">{{errors.password[0]}}</span>
                        	</div>
                        	<div :class="['form-group', errors.password_confirmation ? 'has-error' : '']">
                        		<label>Confirm New Password</label>
                        		<input type="password" name="cnewpassword" v-model="passwordForm.password_confirmation" class="form-control disabledPwInitially" placeholder="Confirm New Password">
                        		<span v-if="errors.password_confirmation" :class="['badge bg-danger']">Enter a valid password.</span>
                        	</div>
      </div>
      <div class="modal-footer">
      	<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      	<button type="submit" class="btn btn-primary">Submit</button>
      </div>
      </form>
    </div>
	</div>
</div>



            <div class="modal fade" style="display: none; padding-right: 12px;" aria-hidden="true" id="addAddressModal">
                <div class="modal-lg modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Add/Modify Address</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <form @submit.prevent="addAddress" @keydown="addressForm.onKeydown($event)" role="form">
                            <div class="modal-body">
                                <div :class="['form-group', errors.address1 ? 'has-error' : '']">
                                    <label>Address Line 1</label>
                                    <input type="text" name="address1" v-model="addressForm.address1" class="form-control" placeholder="Address Line 1">
                                    <span v-if="errors.address1" :class="['badge bg-danger']">Enter a valid text.</span>
                                </div>
                                <div :class="['form-group', errors.address2 ? 'has-error' : '']">
                                    <label>Address Line 2</label>
                                    <input type="text" name="address2" v-model="addressForm.address2" class="form-control" placeholder="Address Line 2">
                                    <span v-if="errors.address2" :class="['badge bg-danger']">Enter a valid text.</span>
                                </div>
                                <div :class="['form-group', errors.address3 ? 'has-error' : '']">
                                    <label>Address Line 3</label>
                                    <input type="text" name="address3" v-model="addressForm.address3" class="form-control" placeholder="Address Line 3">
                                    <span v-if="errors.address3" :class="['badge bg-danger']">Enter a valid text.</span>
                                </div>
                                <div :class="['form-group', errors.pincode ? 'has-error' : '']">
                                    <label>Pincode</label>
                                    <input type="number" name="pincode" v-model="addressForm.pincode" class="form-control" placeholder="Enter your Pincode" min="100000">
                                    <span v-if="errors.pincode" :class="['badge bg-danger']">Enter a valid pincode.</span>
                                </div>
                                <div :class="['form-group', errors.district ? 'has-error' : '']">
                                    <label>District</label>
                                    <input type="text" name="district" v-model="addressForm.district" class="form-control" placeholder="Enter your District">
                                    <span v-if="errors.district" :class="['badge bg-danger']">Enter a valid district.</span>
                                </div>
                                <div :class="['form-group', errors.state ? 'has-error' : '']">
                                    <label>State</label>
                                    <input type="text" name="state" v-model="addressForm.state" class="form-control" placeholder="Enter your State">
                                    <span v-if="errors.state" :class="['badge bg-danger']">Enter a valid state.</span>
                                </div>
                                <div :class="['form-group', errors.country ? 'has-error' : '']">
                                    <label>Country</label>
                                    <input type="text" name="country" v-model="addressForm.country" class="form-control" placeholder="Enter your Country">
                                    <span v-if="errors.country" :class="['badge bg-danger']">Enter a valid country.</span>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary">Add/Modify</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>





            <div class="modal fade" style="display: none; padding-right: 12px;" aria-hidden="true" id="addGSTModal">
                <div class="modal-lg modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Add/Modify GST</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <form @submit.prevent="addGST" @keydown="form.onKeydown($event)" role="form">
                            <div class="modal-body">
                                <div :class="['form-group', errors.address1 ? 'has-error' : '']">
                                    <label>GST Number</label>
                                    <input type="text" name="gst_number" v-model="gstForm.gst_number" class="form-control" placeholder="Enter Your GST NUmber">
                                    <span v-if="errors.gst_number" :class="['badge bg-danger']">Enter a valid GST Number.</span>
                                </div>
                                <div :class="['form-group', errors.details ? 'has-error' : '']">
                                    <label>Details</label>
                                    <input type="text" name="details" v-model="gstForm.details" class="form-control" placeholder="Enter the Details">
                                    <span v-if="errors.details" :class="['badge bg-danger']">Enter a valid details.</span>
                                </div>
                                <div :class="['form-group', errors.address_id ? 'has-error' : '']">
                                    <label>Address</label>
                                    <select v-model="gstForm.address_id" class="form-group">
                                        <option v-for="addr in addresses" :value="addr.id">{{addr.address1}}, {{addr.address2}}, {{addr.address3}}, {{addr.district}}, {{addr.state}}, {{addr.pincode}}</option>
                                    </select>
                                    <span v-if="errors.address_id" :class="['badge bg-danger']">Please choose a valid address.</span>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary">Add/Modify</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

<br>
      <br>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAuctionManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {datatable:Datatable, pagination:Pagination},


        created(){
        	this.getUsers();
        },

    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'20%', label:'Name', name:'name'},
      			{width:'20%', label:'Buyer Name', name:'buyer_name'},
      			{width:'20%', label:'E-Mail', name:'email'},
      			{width:'10%', label:'Mobile', name:'mobile'},
                {width:'10%', label:'Update', name:'records'},
      			{width:'20%', label: 'View More', name:'ops'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		users: [],
         		errors: [],
         		gst: [],
         		addresses: [],
                user_id:'',
         		userForm: new Form({
    					user_id: this.user_id,
    					name: '',
    					buyer_name: '',
    					mobile: '',
    					email: ''
    				}),

                addressForm: new Form({
                    address1: '',
                    address2: '',
                    address3: '',
                    pincode: '',
                    district: '',
                    state: '',
                    country: '',
                    owner_id: this.user_id,
                    id: ''
                }),

    				passwordForm: new Form({
        			user_id: '',
        			password: '',
        			password_confirmation: ''
        		}),

                gstForm: new Form({
                    gst_number: '',
                    details: '',
                    user_id: '',
                    address_id: '',
                    id: ''
                }),

        		searchName: '',
        		searchNumber: ''
         }
       },

       methods: {
       	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},

      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},

     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},

       	getUsers(url="/api/getBuyers"){
       		axios.post(url, {params: this.tableData, searchName: this.searchName, searchNumber: this.searchNumber})
       		.then(response => {
       			this.users = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},

            showgst(g){
                this.gst = g;
                $("#gstModal").modal("show");
            },

            showaddress(g){
                this.addresses = g;
                $("#addressModal").modal("show");
            },

           addAddress(){
               axios.post("/api/addAddress",{
                   id: this.user_id,
                   owner_id: this.user_id,
                   address1: this.addressForm.address1,
                   address2: this.addressForm.address2,
                   address3: this.addressForm.address3,
                   pincode: this.addressForm.pincode,
                   district: this.addressForm.district,
                   state: this.addressForm.state,
                   country: this.addressForm.country,
                   zone: this.addressForm.zone
               })
               // this.addressForm.post("/api/addAddress")
                   .then(() => {
                       toast.fire({
                           icon: 'success',
                           title: 'Address Added'
                       });
                       console.log("success");
                       this.getUsers();
                       this.addressForm.reset();
                   })
                   .catch(() => {
                       toast.fire({
                           icon: 'error',
                           title: 'Failed!'
                       });
                   });
           },

           modalOpener(id){
               $("#"+id).modal("show");
           },

           openAddressModal(user){
               this.user_id=user.id;
               $("#addAddressModal").modal("show");
           },

           editAddress(address){
               this.addressForm.fill(address);
               $("#addModal").modal("show");
           },

           deleteAddress(id){
               axios.post("/api/deleteAddress", {id: id})
                   .then(() => {
                       this.getUsers();
                   })
                   .catch(() => {
                       toast.fire({
                           icon: 'error',
                           title: 'Failed!'
                       });
                   });
           },

           addGST(){
               axios.post("/api/addGST",{
                   id: this.user_id,
                   user_id: this.user_id,
                   gst_number: this.gstForm.gst_number,
                   details: this.gstForm.details,
                   address_id: this.gstForm.address_id,
               })
                   .then(() => {
                       toast.fire({
                           icon: 'success',
                           title: 'GST Updated'
                       });
                       console.log("success");
                       this.getUsers();
                       this.gstForm.reset;
                   })
                   .catch(() => {
                       toast.fire({
                           icon: 'error',
                           title: 'Failed!'
                       });
                   });
           },

           editGST(user){
               this.user_id=user.id;
               this.gstForm.fill(user.gsts);
               $("#addGSTModal").modal("show");
           },

           openGSTModal(user){
               this.user_id=user.id;
               $("#addGSTModal").modal("show");
           },

           changeGST(status, id){
               axios.post("/api/changeGST", {id: id, status: status})
                   .then(() => {
                       toast.fire({
                           icon: 'success',
                           title: 'GST Updated'
                       })
                       this.getUsers();
                   })
                   .catch(() => {
                       toast.fire({
                           icon: 'error',
                           title: 'Failed!'
                       });
                   });
           },

           getUser(id){
    				axios.post("/api/getContact", {id: id})
    				.then(response =>{
    					this.userForm.fill(response.data);
    					this.userForm.user_id = response.data.id;
    					$("#userModal").modal("show");
    				})
    			},

       	addContact(){
    				this.userForm.post('/api/addContactInfo')
    					.then(()=>{
      	     		toast.fire({
      		      	type: 'success',
                	title: 'Updation Complete'
            		});
            		this.errors = [];
            		this.getUsers();
    				})
    				.catch((errors)=>{
            	toast.fire({
      	      	type: 'error',
              	title: 'Updation Failed'
            	});
            	this.errors = errors.response.data.errors;
          	})
      },
      changePassword(){
        		this.passwordForm.post("/api/changeAdminPassword")
        		.then(response => {
        			if(response.data == 0){
        				toast.fire({
      		      	type: 'success',
                	title: 'Password Changed'
            		});
            		this.errors = []
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	pwModal(id){
        		this.passwordForm.user_id = id;
        		$("#pwModal").modal("show");
        	}
    }
 }
</script>
